export const isJsonString = (str: string): boolean => {
    try {
        JSON.parse(str)
    } catch (e) {
        return false
    }
    return true
}


export function isJson(value: string): boolean {
    try {
        value = JSON.stringify(value)
        let rgx = value.trim().match(/^[[{].*[}\]]$/s)
        if (!rgx) return false

        JSON.parse(value)
        return true
    } catch (e) {
        return false
    }
}

export function isNullOrUndefined<T>(obj: T | null | undefined): obj is null | undefined {
    return typeof obj === 'undefined' || obj === null
}